// extracted by mini-css-extract-plugin
export default {"container":"LabelGroup_container__cU8M0"};